var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommitmentCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M29.75 14.1667H4.25M22.6667 2.83333V8.5M11.3333 2.83333V8.5M11.05 31.1667H22.95C25.3302 31.1667 26.5203 31.1667 27.4295 30.7034C28.2291 30.296 28.8793 29.6458 29.2868 28.8461C29.75 27.937 29.75 26.7469 29.75 24.3667V12.4667C29.75 10.0864 29.75 8.89633 29.2868 7.98721C28.8793 7.18752 28.2291 6.53735 27.4295 6.12989C26.5203 5.66667 25.3302 5.66667 22.95 5.66667H11.05C8.66978 5.66667 7.47967 5.66667 6.57054 6.12989C5.77085 6.53735 5.12068 7.18752 4.71322 7.98721C4.25 8.89633 4.25 10.0864 4.25 12.4667V24.3667C4.25 26.7469 4.25 27.937 4.71322 28.8461C5.12068 29.6458 5.77085 30.296 6.57054 30.7034C7.47967 31.1667 8.66978 31.1667 11.05 31.1667Z",
    stroke: "#0D70DC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitmentCalendar);
export default __webpack_public_path__ + "static/media/commitment-calendar.fb3551b5513d82265aa40624d1efcb6b.svg";
export { ForwardRef as ReactComponent };